import { SERVER_URL } from "../utils/apiHelper"
import { TError, TServiceResponse } from "./Modals"

export const throwError = (reason: string, code: string): TError => {
    return { reason, code }
}

export const respond = <T>(data: T | null, error: TError | null): TServiceResponse<T | null> => {
    return { data, error }
}

export const baseUrlIncluded = (url: string) => {
    return url.indexOf('http://') > -1 || url.indexOf('https://') > -1
}

export type THttpPostRequestParams = {
    method: 'POST',
    body: any,
    url: string,
    cookies?: boolean,
    headers?: Headers
}
export type THttpGetRequestParams = {
    method: 'GET',
    url: string,
    cookies: boolean,
    headers: Headers
}
export type THttpRequestParams = THttpGetRequestParams | THttpPostRequestParams

const stringResAPI=['/sendOtp', '/sendOtpForCustomer', '/createProductScanException']
export const httpRequest = async<T>(params: THttpRequestParams) => {
    try {
        const { method, url, cookies, headers } = params
        let body: any;
        if (method === 'POST') body = params.body

        const response = await fetch(url, {
            method,
            body: JSON.stringify(body),
            headers,
            credentials: Boolean(cookies) ? 'include' : undefined,
            mode: Boolean(cookies) ? 'cors' : undefined,
            
        })

        const parsedResponse: T = stringResAPI.includes(url.substring(SERVER_URL.length)) ? await response.text() : await response.json()
        if (!response.ok) throw parsedResponse
        return respond(parsedResponse, null)
    } catch (e) {
        const error: TError = { code: '100', reason: '' };

        if (e instanceof TypeError) {
            error.reason = e.message
        }
        else {
            if(typeof e === 'string') e = JSON.parse(e)
            const { code, reason } = e as TError
            error.code = code
            error.reason = reason
        }
        return respond(null, error)
    }
}

export const POST = async<T>(url: string, body: any, cookies = false, headers?: Headers) => {
    if (headers === undefined) {
        headers = new Headers()
        headers.append('Content-Type', 'application/json')
        headers.append('Accept', 'application/json')
        // cookies ==true ? headers.append('sessionId',""):""
    }

    url = baseUrlIncluded(url) ? url : SERVER_URL + url

    return httpRequest<T>({
        url,
        method: 'POST',
        body,
        cookies,
        headers
    })
}

export const GET = async<T>(url: string, cookies = false, headers?: Headers) => {
    if (headers === undefined) {
        headers = new Headers()
        headers.append('Content-Type', 'application/json')
        headers.append('Accept', 'application/json')
    }

    url = baseUrlIncluded(url) ? url : SERVER_URL + url

    return httpRequest<T>({
        url,
        method: 'GET',
        cookies,
        headers
    })
}